export default {
  serverUrl: '/api/',
};
